import { render, staticRenderFns } from "./MagCover.vue?vue&type=template&id=53763405&scoped=true"
import script from "./MagCover.vue?vue&type=script&lang=js"
export * from "./MagCover.vue?vue&type=script&lang=js"
import style0 from "./MagCover.vue?vue&type=style&index=0&id=53763405&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53763405",
  null
  
)

export default component.exports